import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderList as _renderList, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row justify-center" }
const _hoisted_2 = {
  key: 2,
  class: "column flex-center flex-1"
}

import {
  IFilter,
  IFilterModel,
  IQInfiniteScrollData,
  ITableColumn,
  ITableRow,
  QInfiniteScrollDone,
} from 'src/common/interfaces'
import LandingListHeader from 'src/components/landingList/LandingListHeader.vue'
import LandingListTable from 'src/components/landingList/LandingListTable.vue'
import { Ref, ref, watch } from 'vue'

interface IProps {
  columns: ITableColumn[]
  rows: ITableRow[]
  headerBtn?: IHeaderBtn
  rootClass?: string
  headerRootClass?: string
  draggable?: boolean
  hasSearch?: boolean
  hasViewMode?: boolean
  hasFilter?: boolean
  filters?: IFilter[]
  filterModel?: IFilterModel
  hasFooter?: boolean
  totalCount?: number
  perPageOptions?: { label: string; value: number }[]
}

interface IEmits {
  (event: 'row-clicked', data: ITableRow): void
  (event: 'row-dragstart', data: ITableRow): void
  (event: 'row-dragover', data: ITableRow): void
  (event: 'row-dragend'): void
  (event: 'bottom-reached', data: IQInfiniteScrollData): void
  (event: 'filter', data: IFilterModel): void
}

interface IHeaderBtn {
  to: string
  label: string
}

interface IInfiniteScrollComponent {
  stop: () => unknown
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'BaseLandingList', inheritAttrs: false },
  __name: 'BaseLandingList',
  props: /*@__PURE__*/_mergeModels({
    columns: {},
    rows: {},
    headerBtn: { default: () => ({ to: '', label: '' }) },
    rootClass: { default: 'q-px-md q-px-md-lg' },
    headerRootClass: { default: 'bg-white' },
    draggable: { type: Boolean, default: false },
    hasSearch: { type: Boolean, default: true },
    hasViewMode: { type: Boolean, default: false },
    hasFilter: { type: Boolean, default: true },
    filters: { default: () => [] },
    filterModel: { default: () => ({}) },
    hasFooter: { type: Boolean, default: true },
    totalCount: { default: 0 },
    perPageOptions: { default: () => [
    { label: '5', value: 5 },
    { label: '10', value: 10 },
    { label: '25', value: 25 },
    { label: '50', value: 50 },
    { label: '100', value: 100 },
    { label: '200', value: 200 },
  ] }
  }, {
    "rowsPerPage": { type: Number, default: 100 },
    "rowsPerPageModifiers": {},
    "page": { type: Number, default: 100 },
    "pageModifiers": {},
    "modelValue": { default: () => [] },
    "modelModifiers": {},
    "search": { type: String, default: '' },
    "searchModifiers": {},
    "cardViewMode": { type: Boolean, default: false },
    "cardViewModeModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["row-clicked", "row-dragstart", "row-dragover", "row-dragend", "bottom-reached", "filter"], ["update:rowsPerPage", "update:page", "update:modelValue", "update:search", "update:cardViewMode"]),
  setup(__props: any, { emit: __emit }) {



const rowsPerPage = _useModel(__props, 'rowsPerPage')
const page = _useModel(__props, 'page')

const props = __props

const emit = __emit

/* -------------------------------- Constants ------------------------------- */

const paginationRef = ref({
  totalCount: props.totalCount,
  rowsNumber: 100,
})

const cardViewRef = ref()
const infiniteScrollRef: Ref<null | IInfiniteScrollComponent> = ref(null)

// const pagesNumber = computed(() => Math.ceil(paginationRef.value.totalCount / rowsPerPage.value))

const model = _useModel<ITableRow[]>(__props, "modelValue")
const searchModel = _useModel(__props, 'search')
const cardViewModel = _useModel(__props, 'cardViewMode')

watch(
  () => props.totalCount,
  (newTotalCount) => (paginationRef.value.totalCount = newTotalCount),
)
watch(
  () => props.hasFooter,
  (paginationStatus) => {
    if (paginationStatus) rowsPerPage.value = 10
    else rowsPerPage.value = 0
  },
)
watch(
  () => rowsPerPage.value,
  (newRowsPerPage) => (rowsPerPage.value = newRowsPerPage),
)

watch(
  () => rowsPerPage.value,
  (newRowsPerPage) => {
    paginationRef.value.rowsNumber = newRowsPerPage
  },
)

/* -------------------------------- Functions ------------------------------- */

function handleListPagination(event: { rowsPerPage: number; page: number }) {
  rowsPerPage.value = event.rowsPerPage
  page.value = event.page
}

function onLoadRef(index: number, done: QInfiniteScrollDone) {
  if (props.rows.length >= props.totalCount && infiniteScrollRef.value !== null) infiniteScrollRef.value.stop()
  else emit('bottom-reached', { page: index + 1, done })
}

return (_ctx: any,_cache: any) => {
  const _component_k_divider = _resolveComponent("k-divider")!
  const _component_q_spinner_dots = _resolveComponent("q-spinner-dots")!
  const _component_q_infinite_scroll = _resolveComponent("q-infinite-scroll")!
  const _component_q_spinner = _resolveComponent("q-spinner")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["BaseLandingList flex-1 flex column no-wrap overflow-hidden", __props.rootClass])
  }, [
    _renderSlot(_ctx.$slots, "header", {}, () => [
      _createVNode(LandingListHeader, _mergeProps({
        search: searchModel.value,
        "onUpdate:search": _cache[0] || (_cache[0] = ($event: any) => ((searchModel).value = $event)),
        "card-view-mode": cardViewModel.value,
        "onUpdate:cardViewMode": _cache[1] || (_cache[1] = ($event: any) => ((cardViewModel).value = $event)),
        "filter-model": __props.filterModel,
        filters: __props.filters,
        "root-class": __props.headerRootClass,
        disable: !__props.rows.length,
        "has-search": __props.hasSearch,
        "has-view-mode": __props.hasViewMode,
        "has-filter": __props.hasFilter
      }, __props.headerBtn, {
        onFilter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('filter', $event)))
      }), _createSlots({
        default: _withCtx(() => [
          (_ctx.$slots['action-buttons'])
            ? _renderSlot(_ctx.$slots, "action-buttons", { key: 0 })
            : _createCommentVNode("v-if", true),
          (_ctx.$slots['action-btn'])
            ? _renderSlot(_ctx.$slots, "action-btn", { key: 1 })
            : _createCommentVNode("v-if", true)
        ]),
        _: 2 /* DYNAMIC */
      }, [
        (_ctx.$slots['create-action'])
          ? {
              name: "create-action",
              fn: _withCtx(() => [
                _renderSlot(_ctx.$slots, "create-action")
              ]),
              key: "0"
            }
          : undefined,
        (_ctx.$slots['extra-actions'])
          ? {
              name: "extra-actions",
              fn: _withCtx(() => [
                _renderSlot(_ctx.$slots, "extra-actions")
              ]),
              key: "1"
            }
          : undefined,
        (_ctx.$slots['filter-actions'])
          ? {
              name: "filter-actions",
              fn: _withCtx(() => [
                _renderSlot(_ctx.$slots, "filter-actions")
              ]),
              key: "2"
            }
          : undefined
      ]), 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["search", "card-view-mode", "filter-model", "filters", "root-class", "disable", "has-search", "has-view-mode", "has-filter"])
    ]),
    _renderSlot(_ctx.$slots, "title"),
    _renderSlot(_ctx.$slots, "table", {}, () => [
      (!__props.cardViewMode)
        ? (_openBlock(), _createBlock(LandingListTable, _mergeProps({
            key: 0,
            modelValue: model.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((model).value = $event)),
            columns: __props.columns,
            rows: __props.rows,
            draggable: __props.draggable,
            "rows-per-page": rowsPerPage.value,
            "total-count": __props.totalCount,
            "per-page-options": __props.perPageOptions,
            "has-footer": __props.hasFooter
          }, _ctx.$attrs, {
            onRowClicked: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('row-clicked', $event))),
            onRowDragstart: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('row-dragstart', $event))),
            onRowDragend: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('row-dragend'))),
            onRowDragover: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('row-dragover', $event))),
            onRequest: handleListPagination
          }), _createSlots({ _: 2 /* DYNAMIC */ }, [
            (_ctx.$slots['header-action'])
              ? {
                  name: "header-action",
                  fn: _withCtx(({ localProps }) => [
                    _renderSlot(_ctx.$slots, "header-action", { localProps: localProps })
                  ]),
                  key: "0"
                }
              : undefined,
            (_ctx.$slots['row-action'])
              ? {
                  name: "row-action",
                  fn: _withCtx(({ localProps }) => [
                    _renderSlot(_ctx.$slots, "row-action", { localProps: localProps })
                  ]),
                  key: "1"
                }
              : undefined,
            _renderList(_ctx.$slots, (_, name) => {
              return {
                name: name,
                fn: _withCtx((slotData) => [
                  _renderSlot(_ctx.$slots, name, _normalizeProps(_guardReactiveProps(slotData)))
                ])
              }
            })
          ]), 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["modelValue", "columns", "rows", "draggable", "rows-per-page", "total-count", "per-page-options", "has-footer"]))
        : _createCommentVNode("v-if", true)
    ]),
    (__props.cardViewMode)
      ? (_openBlock(), _createBlock(_component_k_divider, {
          key: 0,
          size: "md"
        }))
      : _createCommentVNode("v-if", true),
    (__props.cardViewMode)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          ref_key: "cardViewRef",
          ref: cardViewRef,
          class: "column flex-1 overflow-auto hide-scrollbar"
        }, [
          (!_ctx.$attrs.loading && __props.totalCount > 0)
            ? (_openBlock(), _createBlock(_component_q_infinite_scroll, {
                key: 0,
                ref_key: "infiniteScrollRef",
                ref: infiniteScrollRef,
                offset: 100,
                "scroll-target": cardViewRef.value,
                class: "full-height",
                onLoad: onLoadRef
              }, _createSlots({
                default: _withCtx(() => [
                  (__props.cardViewMode)
                    ? _renderSlot(_ctx.$slots, "card-view", { key: 0 })
                    : _createCommentVNode("v-if", true)
                ]),
                _: 2 /* DYNAMIC */
              }, [
                (__props.rows.length !== __props.totalCount)
                  ? {
                      name: "loading",
                      fn: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                          _createVNode(_component_q_spinner_dots, {
                            color: "cool-gray-40",
                            size: "40px"
                          })
                        ])
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["scroll-target"]))
            : (!_ctx.$attrs.loading)
              ? _renderSlot(_ctx.$slots, "card-view", { key: 1 })
              : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_q_spinner, {
                    size: "4em",
                    color: "cool-gray-40"
                  })
                ]))
        ], 512 /* NEED_PATCH */))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" <div v-if=\"cardViewMode\" class=\"row full-width justify-between items-center q-pb-20\">\n      <k-divider size=\"md\" color=\"cool-gray-30\" class=\"q-mb-md\" />\n      <div class=\"flex items-center justify-between full-width\">\n        <k-export-csv size=\"sm\" :rows=\"rows\" :columns=\"columns\" :disable=\"!rows.length\" :disabled=\"!rows.length\" />\n        <k-pagination\n          v-model:per-page=\"rowsPerPage\"\n          v-model=\"page\"\n          :max=\"pagesNumber\"\n          :total=\"paginationRef.totalCount\"\n          :per-page-options=\"perPageOptions\"\n          @update:model-value=\"(newPage: number) => handleListPagination({ rowsPerPage, page: newPage })\"\n          @update:per-page=\"(newRowsPerPage: number) => handleListPagination({ rowsPerPage: newRowsPerPage, page: 1 })\"\n        />\n      </div>\n    </div> ")
  ], 2 /* CLASS */))
}
}

})